import { render, staticRenderFns } from "./SelecioneEqComp.vue?vue&type=template&id=2c790e88&scoped=true&"
import script from "./SelecioneEqComp.vue?vue&type=script&lang=js&"
export * from "./SelecioneEqComp.vue?vue&type=script&lang=js&"
import style0 from "./SelecioneEqComp.vue?vue&type=style&index=0&id=2c790e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c790e88",
  null
  
)

export default component.exports